import { useScrollReveal } from '@/hooks/useScrollReveal';

interface ProductSpecsProps {
  specs?: { Label: string; Value: string }[];
}

function SectionReveal({ children, className = '', delay = 0 }: { children: React.ReactNode; className?: string; delay?: number }) {
  const { ref, isVisible } = useScrollReveal();
  return (
    <div
      ref={ref}
      className={`scroll-reveal ${isVisible ? 'scroll-reveal-visible' : ''} ${delay > 0 ? `scroll-reveal-delay-${Math.min(delay, 6)}` : ''} ${className}`}
    >
      {children}
    </div>
  );
}

export default function ProductSpecs({ specs: managedSpecs = [] }: ProductSpecsProps) {
  const specs = managedSpecs
    .map((item) => ({ label: item.Label.trim(), value: item.Value.trim() }))
    .filter((item) => item.label || item.value);

  if (specs.length === 0) return null;

  return (
    <SectionReveal>
      <div className="bg-white rounded-2xl border border-[#E8E0D6] p-6 md:p-10">
        <div className="flex items-center gap-2 mb-6 md:mb-8">
          <div className="w-8 h-8 rounded-full bg-[#1B3D2A]/10 flex items-center justify-center">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-list-check-2 text-[#1B3D2A]" />
            </div>
          </div>
          <span className="text-xs font-semibold text-[#D4A574] tracking-wider uppercase">Specifications</span>
        </div>
        <h2 className="text-xl md:text-2xl font-bold text-[#1B3D2A] mb-6 md:mb-8">
          產品規格
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0">
          {specs.map((spec, i) => (
            <div
              key={spec.label}
              className={`flex items-center justify-between py-4 px-1 ${
                i !== specs.length - 1 ? 'border-b border-[#E8E0D6]/50' : ''
              } ${i % 2 === 0 && i !== specs.length - 1 ? 'md:border-r md:pr-6 md:mr-6' : ''} ${i % 2 === 1 ? 'md:pl-6' : ''}`}
            >
              <span className="text-sm text-[#5A6B5A]">{spec.label}</span>
              <span className="text-sm font-semibold text-[#1B3D2A] text-right ml-4">
                {spec.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </SectionReveal>
  );
}
